/**
 * Clave de la query que responde "¿este navegador ya tiene credencial?" (`hasKey()`).
 *
 * Vive aquí, y no en `routes/index.tsx`, porque la escriben las dos pantallas que crean la clave
 * —`enroll` de la activación (US2) y `claim` de la re-vinculación (US3)— y así ningún módulo de
 * `features/` tiene que importar una ruta.
 *
 * `routes/index.tsx` la consulta con `staleTime: Number.POSITIVE_INFINITY` (una clave no aparece ni
 * desaparece sola), de modo que quien la crea **debe** dejarla en `true`: si no, `HomeGate`
 * seguiría leyendo el `false` del primer arranque y rebotaría a `/dispositivo-no-registrado` con la
 * sesión ya establecida.
 */
export const DEVICE_KEY_QUERY_KEY = ['device-key'] as const;
